import React, { useState, useEffect, useRef } from 'react';
import "../layout/styles/inline-cgos.css";
import "../layout/styles/bootstrap-table.css";
import "../layout/styles/bootstrap-select.min.css";
import { ChequeCultureLegacy } from "./legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../service/ChequeCultureService";
import { LinkProviderService } from "../service/LinkProviderService";
import { useParams } from "react-router-dom";


export const ServiceIndisponible = () => {

    
    const { errorId } = useParams();
    const linkService = new LinkProviderService();
    const errorMessageFiles=<div><h3>Echec de l'envoi d'un document </h3><h4>Une anomalie dans un document empêche l'enregistrement de votre demande.</h4></div>;
    const defaultErrorMessage=<div><h3>Problème technique inattendu</h3>
    <h4>En raison d’un problème technique, votre demande de prestation ne peut pas être traitée pour le moment.</h4></div>;
    const messagePourCorriger=<div><h4>Effectuer les actions suivantes pour corriger le probléme :
                                <ul className="ul-sans-dot"><li>1. Re-numérisez le document,</li><li>2. Donnez-lui un nouveau nom,</li><li>3. Renvoyer votre demande de prestation.</li></ul></h4></div>


    return (
        <div className="grid">
            <ChequeCultureLegacy/>
            <div className="col-12">
                <div className="card">
                    <div class="alert alert-danger" role="alert">

                        {!errorId.startsWith("FH") && defaultErrorMessage}
                        {errorId.startsWith("FH") && errorMessageFiles}
                        <h4>&nbsp; &#x25cf;{errorId.startsWith("FH") && localStorage.getItem("errorMessage").replace("FileHandler Error DependencyFichier",'')}</h4>
                        <h4>&nbsp; &#x25cf; Code erreur : {errorId}</h4>
                        <br>
                        </br>
                        {errorId.startsWith("FH") && messagePourCorriger}
                        <br>
                        </br>
                        {!errorId.startsWith("FH") &&<h4>Merci de réessayer à un autre moment</h4>}
                        <h4 className="text-black">Retour à la page<a href={linkService.getRetourEaMembrePrestation()} > PRESTATIONS ET FORMULAIRES</a></h4>
                    </div>
                </div>
            </div>
            
            
        </div>
    )
}
